import { authRepository } from '../../consumePlayer/repository/AuthRepository'
import { LeaveGameService } from './LeaveGameService'

export const leaveGameService = new LeaveGameService(authRepository)
